import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.patient-simple-create-action': {
         addNewPatient: 'Dodaj nowego pacjenta',
         phoneNumber: 'Numer telefonu',
         shouldFillAtLeastOneField: 'Należy wypełnić przynajmniej jedno pole',
         successullyAddedPatient:
            'Pomyślnie dodano pacjenta - przed rozpoczęciem wizyty konieczne będzie dodanie brakujących danych.',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.patient-simple-create-action'
);
